import React, { useEffect, useRef } from "react";
import { useSetState } from "ahooks";
import { useAtom } from "jotai";
import { DatePicker, InputNumber, message, Select } from "antd";
import { SActionBtn, SDrawerOrModal, SLowcodeList, STableActions } from "shj-components";
import { SPUDataAtom } from '@/pages/combinationManage/components/store.js'
import {
  productCombinationDetailBatchInsert
} from "@/services/product.ts";
import { getEnums } from "@/services/homeService.ts";

import ChooseSPUModal from "@/pages/combinationManage/components/ChooseSPUModal";
import ChooseSKUModal from "@/pages/combinationManage/components/ChooseSKUModal";
import { config } from './config.jsx'
import dayjs from "dayjs";

const AddSubProductModal = (props) => {
  const { open, onClose, onReload, query = {} } = props;
  const listRef = useRef();
  const [state, setState] = useSetState({
    SPUOpen: false,
    SKUOpen: false,
    record: {},
    loading: false,
    typeList: [],
  })

  const [SPUData, setSPUData] = useAtom(SPUDataAtom)

  const onDelSPU = (productId) => {
    const newData = SPUData.dataSource.filter(item => item.productId !== productId)
    setSPUData((SPUData) => ({ ...SPUData, dataSource: newData }))
    message.success('删除成功')
  }

  useEffect(() => {
    if (open) {
      getOptions()
      console.log(query)
    }
  }, [ open]);

  const getOptions = async () => {
    setState({ loading: true })
    try {
      const data = await getEnums('plus-product', 'com.shj.saas.plus.product.enums.ProductCombinationDetailSelectType')
      setState({ typeList: data?.map(item => ({ label: item.description, value: item.key })) })
    } finally {
      setState({ loading: false })
    }
  }

  const onAddSPU = () => {
    setState({ SPUOpen: true })
  }

  const onChangeValue = (record, v, key) => {
    // const newVal = key.includes('Date') ? (v && dayjs(v).format('YYYY-MM-DD')) : v
    const newData = SPUData.dataSource.map(item => {
      if (item.productId === record.productId) {
        return {
          ...item,
          [key]: v,
          [key === 'selectType' ? 'skuIds' : ''] : [],
        }
      }
      return item
    })
    setSPUData((SPUData) => ({ ...SPUData, dataSource: newData }))
  }

  const onFinish = () => {
    if (SPUData.dataSource?.length <= 0) {
      message.error('请选择至少一条SPU');
      return;
    }
    const notSkuList = SPUData.dataSource?.filter(item => item.selectType !== 'ALL' && !(item.skuIds && item.skuIds?.length > 0))
    if (notSkuList?.length > 0) {
      const nameList = notSkuList.map(item => item.productName).join(',')
      message.error(`【${nameList}】请选择至少一条SKU`);
      return;
    }
    setState({ loading: true })
    productCombinationDetailBatchInsert({
      ...query,
      productList: SPUData.dataSource?.map(item => ({
        productId: item.productId,
        productName: item.productName,
        productSourceName: item.sourceTypeName,
        productStatus: item.enabled,
        startDate: item.startDate ? dayjs(item.startDate).format('YYYY-MM-DD') : undefined,
        endDate: item.endDate ? dayjs(item.endDate).format('YYYY-MM-DD') : undefined,
        unitInfo: item.unitInfo,
        size: item.size,
        picSort: item.picSort,
        selectType: item.selectType,
        skuIds: item.skuIds,
      })),
    }).then(res => {
      message.success(res.message || '操作成功')
      setSPUData({ dataSource: [] })
      onClose?.()
      onReload?.()
    }).finally(() => {
      setState({ loading: false })
    })
  }

  const extension = {
    dataSource: SPUData.dataSource,
    events: { onAddSPU },
    customRender: {
      nameRender(v, record) {
        return <>
          <div style={{ maxWidth: 200, whiteSpace: 'wrap', wordBreak: 'break-all' }}>{v}</div>
          {record.productId}
          </>
      },
      numRender(v, record) {
        return <InputNumber style={{ width: '100%' }}
                            min={0.0001}
                            max={999999999.9999}
                            step={0.0001}
                            precision={4}
                            value={v || 1}
                            onChange={(v) => onChangeValue(record, v, 'size')}/>
      },
      sortNumRender(v, record) {
        return <InputNumber style={{ width: '100%' }}
                            placeholder={'请输入附图顺序'}
                            min={1}
                            max={999999999}
                            step={1}
                            precision={0}
                            value={v}
                            onChange={(v) => onChangeValue(record, v, 'picSort')}/>
      },
      startRender(v, record){
        return <DatePicker style={{ width: '100%' }}
                           value={v || dayjs()}
                           allowClear={false}
                           disabledDate={(current) => current && current < dayjs().startOf('day')}
                           onChange={(v) => onChangeValue(record, v, 'startDate')}/>
      },
      endRender(v, record){
        return <DatePicker style={{ width: '100%' }}
                           value={v}
                           disabledDate={(current) => current && current < dayjs(record.startDate).add(1, 'day').startOf('day')}
                           onChange={(v) => onChangeValue(record, v, 'endDate')}/>
      },
      typeSelectRender(v, record) {
        return <Select style={{ width: '100%' }}
                       value={v || 'ALL'}
                       options={state.typeList}
                       onChange={(v) => onChangeValue(record, v, 'selectType')}/>
      },
      actionRender(productId, record) {
        return <STableActions>
          {record.selectType !== 'ALL' &&
              <SActionBtn onClick={() => setState({ SKUOpen: true, record })}>SKU选择</SActionBtn>}
          <SActionBtn onClick={() => onDelSPU(productId)}>移除</SActionBtn>
        </STableActions>
      }
    }
  }

  const onReloadList = () => {

  }

  return <>
    <SDrawerOrModal
      title={'添加子产品'}
      width={1000}
      open={open}
      loading={state.loading}
      onCancel={()=> {
        onClose();
        setSPUData({ dataSource: [], chooseSku: [] })
      }}
      onOk={onFinish}
    >
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extension}/>
    </SDrawerOrModal>
    {state.SPUOpen && <ChooseSPUModal
        open={state.SPUOpen}
        onClose={() => setState({ SPUOpen: false })}
        onReload={onReloadList}
    />}
    {state.SKUOpen && <ChooseSKUModal
        spuData={state.record}
        open={state.SKUOpen}
        onClose={() => setState({ SKUOpen: false })}
        onReload={onReloadList}
    />}
  </>
}

export default AddSubProductModal